import { useEffect, useRef } from 'react';

import type { Customer } from '@/modules/customer/domain/Customer';

export const useBrazeCommerceToolsId = (customer: Customer | null) => {
  const lastCommerceToolsId = useRef<string | null>(null);

  useEffect(() => {
    if (!customer?.id) return;

    const braze = window.braze;
    if (!braze) return;

    const user = braze.getUser?.();
    if (!user) return;

    if (lastCommerceToolsId.current === customer.id) return;

    try {
      user.setCustomUserAttribute('commerce_tools_id', customer.id);

      lastCommerceToolsId.current = customer.id;
    } catch (error) {
      console.error('[Braze] setCommerceToolsId failed', error);
    }
  }, [customer?.id]);
};
